import { z } from 'zod';

/**
 * Admin → AI (Anthropic) kimlik bilgisi güncelleme.
 * - apiKey: Anthropic API key (sk-ant-...). Boş string → temizleme.
 * - model: receipt scan modeli override (boş → varsayılan claude-haiku-4-5).
 * En az bir alan gönderilmeli.
 */
export const updateAiCredentialsSchema = z
  .object({
    apiKey: z
      .string()
      .max(200)
      .regex(/^(|sk-ant-[A-Za-z0-9_-]+)$/, 'Geçersiz Anthropic API key formatı (sk-ant-...)')
      .optional(),
    model: z.string().max(120).optional(),
  })
  .refine((d) => d.apiKey !== undefined || d.model !== undefined, {
    message: 'En az bir alan güncellenmeli',
  });
export type UpdateAiCredentialsInput = z.infer<typeof updateAiCredentialsSchema>;
